<div class="loaderIcon">
    <div class="hourglass" *ngIf="loadHourGlassLoader"></div>
</div>